import React from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

const DiseaseImages = ({ id }) => {
    const data = useStaticQuery(graphql`
        query {
            cover_01: file(relativePath: { eq: "disease/motif/cover_01.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_02: file(relativePath: { eq: "disease/motif/cover_02.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_03: file(relativePath: { eq: "disease/motif/cover_03.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_04: file(relativePath: { eq: "disease/motif/cover_04.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_05: file(relativePath: { eq: "disease/motif/cover_05.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_06: file(relativePath: { eq: "disease/motif/cover_06.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_07: file(relativePath: { eq: "disease/motif/cover_07.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_08: file(relativePath: { eq: "disease/motif/cover_08.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_09: file(relativePath: { eq: "disease/motif/cover_09.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_10: file(relativePath: { eq: "disease/motif/cover_10.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_11: file(relativePath: { eq: "disease/motif/cover_11.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }

            motif_1: file(relativePath: { eq: "disease/motif/motif_1.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_2: file(relativePath: { eq: "disease/motif/motif_2.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_3: file(relativePath: { eq: "disease/motif/motif_3.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_4: file(relativePath: { eq: "disease/motif/motif_4.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_5: file(relativePath: { eq: "disease/motif/motif_5.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_6: file(relativePath: { eq: "disease/motif/motif_6.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_7: file(relativePath: { eq: "disease/motif/motif_7.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_8: file(relativePath: { eq: "disease/motif/motif_8.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_9: file(relativePath: { eq: "disease/motif/motif_9.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_10: file(relativePath: { eq: "disease/motif/motif_10.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_11: file(relativePath: { eq: "disease/motif/motif_11.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `)

    return (
        <Img style={{ width: "100%" }} fluid={data[id].childImageSharp.fluid} />
    )
}

export default DiseaseImages
